import client from "./client";

const studentAttendanceApi = {
  markClass(body) {
    return client.post("/student-attendance/mark", body).then((r) => r.data);
  },

  getClassAttendance(params = {}) {
    return client.get("/student-attendance/class", { params }).then((r) => r.data);
  },

  getDailyReport(params = {}) {
    return client.get("/student-attendance/daily", { params }).then((r) => r.data);
  },

  getStudentHistory(studentId, params = {}) {
    return client.get(`/student-attendance/student/${studentId}`, { params }).then((r) => r.data);
  },

  lock(body) {
    return client.post("/student-attendance/lock", body).then((r) => r.data);
  },
};

export default studentAttendanceApi;
